import React, {PropTypes} from 'react';
import RemoveCoworkerButton from '../remove-coworker-button';
import Translate from 'react-translate-component';
import { ToolTip } from 'components';
import { toMoney } from '../../amount/amount-helper';
import { proxyCounterpart } from '../../../../scripts/proxyCounterpart';

function generateInputRow (props, title, id, value, toolTip = null, extraDescription = null, detailsRowClass = null) {
  return <InputRow
    title={title}
    extraDescription={extraDescription}
    detailsRowClass={detailsRowClass}
    id={id}
    value={value}
    disabled={props.disabled}
    focus={props.focus}
    currencyName={props.currencyName}
    onBlur={props.onBlur}
    onChange={props.onChange}
    toolTip={toolTip}
  />;
}

function DetailsRow (props) {
  let title = null;
  const detailsRowClass = props.detailsRowClass || '';
  if (props.title) {
    if (props.onClick) {
      title = <b>
        <a onClick={props.onClick}>
          <span>
            + <Translate content={props.title} />
          </span>
        </a>
      </b>;
    } else {
      title = <Translate content={props.title} />;
    }
  }

  return (<div className={'details-row ' + detailsRowClass}>
    <div className='details-left'>
      {title}
      {props.left}
    </div>
    <div className='details-right'>
      {props.right}
    </div>
  </div>
  );
}

function InputRow (props) {
  let title = null;
  const extraDescription = props.extraDescription || null;
  const toolTip = props.toolTip || null;
  const detailsRowClass = props.detailsRowClass || '';
  if (props.title) {
    title = <Translate content={props.title}/>;
  }

  let value = props.value;

  return (<div className={'details-row ' + detailsRowClass}>
    <div className='details-left'>
      {title}
      {extraDescription}
      {toolTip}
    </div>
    <div className='details-right'>
      <div className='currency-input-holder' data-currency={props.currencyName}>
        <input type='text'
          id={props.id}
          disabled={props.disabled}
          onBlur={props.onBlur}
          onClick={props.focus}
          value={toMoney(value)}
          onChange={props.onChange}
        />
      </div>
    </div>
  </div>);
}

function SelectRow (props) {
  let title = null;
  const left = props.left || null;
  if (props.title) {
    title = <Translate content={props.title} />;
  }

  return (<div className='details-row'>
    <div className='details-left'>
      {title}
      {left}
    </div>
    <div className='details-right'>
      <div className='styled-select'>
        <span>
          <select id={props.id}
            value={props.value}
            onChange={props.onChange}
            disabled={props.disabled}
            >
            {props.options}
          </select>
        </span>
      </div>
    </div>
  </div>);
}

// List Rows

function AddCoworker (props) {
  return <DetailsRow
    title='ADD_COWORKER'
    onClick={props.onClick}
    left={<ToolTip
      id='worker'
      buttonClasses='tooltip-info-button'
      msg={proxyCounterpart('TOOLTIP_WORKER')}
    />}
  />;
}

function Allowance (props) {
  let value = props.invoiceUser.calculation ? props.invoiceUser.calculation.allowance : 0;
  if (props.value.userId === props.invoiceUser.userId && props.value.value !== 0 && props.value.type === 'ALLOWANCE') {
    value = props.value.value;
  }

  return generateInputRow(
    props,
    'ALLOWANCE',
    'invoice-allowance-' + props.invoiceUser.userId,
    value,
    <ToolTip id='allowance' msg={proxyCounterpart('TOOLTIP_ALLOWANCE')}/>
  );
}

function CoworkerName (props) {
  return <DetailsRow
    left={<h3>{props.invoiceUser.firstName} {props.invoiceUser.lastName}</h3>}
    right={<RemoveCoworkerButton
      coworkerId={parseInt(props.coworkerId)}
      removeCoworker={props.removeCoworker} />
    }
  />;
}

function DeductionAmount (props) {
  return <DetailsRow
    title='DEDUCTION_AMOUNT'
    // left={<ToolTip id='deduction' msg={proxyCounterpart('TOOLTIP_DEDUCTION')}/>}
    right={props.calculation}
  />;
}

function Divider (props) {
  if ((!props.saveVacationPay && !props.discount) && props.hide) return null;
  return <hr className='thin-line'></hr>;
}

function Gross (props) {
  let value = props.invoiceUser.calculation ? props.invoiceUser.calculation.gross : 0;
  if (props.value.userId === props.invoiceUser.userId && props.value.value !== 0 && props.value.type === 'GROSS') {
    value = props.value.value;
  }
  return generateInputRow(
    props,
    'GROSS_SALARY',
    'invoice-gross-' + props.invoiceUser.userId,
    value,
    <ToolTip id='gross_salary' msg={proxyCounterpart('TOOLTIP_CALCULATION_GROSS_SALARY')}/>
  );
}

function HourlySalary (props) {
  return <DetailsRow
    title={props.title}
    right={props.calculation}
    detailsRowClass='doublePadding'
  />;
}

function InvoiceryFee (props) {
  return <DetailsRow
    title='CALCULATION_INVOICERY_FEE'
    left={<ToolTip id='invoicery_fee' msg={proxyCounterpart('TOOLTIP_CALCULATION_INVOICERY_FEE')}/>}
    right={props.calculation}
  />;
}

function RewardsDiscount (props) {
  if (props.discount !== 0) {
    return <DetailsRow
      title='CALCULATION_REWARDS_DISCOUNT'
      left={<ToolTip id='rewards_discpunt' msg={proxyCounterpart('TOOLTIP_CALCULATION_REWARDS_DISCOUNT')} />}
      right={props.calculation}
      detailsRowClass='doublePaddingLeft'
    />;
  }
  return null;
}

function Net (props) {
  let value = props.invoiceUser.calculation ? props.invoiceUser.calculation.net : 0;
  if (props.value.userId === props.invoiceUser.userId && props.value.value !== 0 && props.value.type === 'NET') {
    value = props.value.value;
  }
  return generateInputRow(
    props,
    'NET_SALARY',
    'invoice-net-' + props.invoiceUser.userId,
    value,
    <ToolTip id='net_salary' msg={proxyCounterpart('TOOLTIP_CALCULATION_NET_SALARY')}/>
  );
}

function PayrollTax (props) {
  return <DetailsRow
    title='CALCULATION_PAYROLL_TAX'
    left={<ToolTip id='payroll_tax' msg={proxyCounterpart('TOOLTIP_CALCULTAION_PAYROLL_TAX')}/>}
    right={props.calculation}
  />;
}

function Pension (props) {
  return <DetailsRow
    title='PENSION'
    left={<ToolTip id='itp' msg={proxyCounterpart('TOOLTIP_ITP')}/>}
    right={props.calculation}
  />;
}

function PensionTax (props) {
  return <DetailsRow
    title='CALCULATION_SPECIAL_PENSION_TAX'
    right={props.calculation}
    left={<ToolTip id='special_pension_tax' msg={proxyCounterpart('TOOLTIP_CALCULATION_SPECIAL_PENSION_TAX')}/>}
  />;
}

function SelectTax (props) {
  return <SelectRow
    title={props.title}
    id={'invoice-taxkeyid-' + props.invoiceUser.userId}
    value={props.invoiceUser.taxkeyId}
    onChange={props.onChange}
    disabled={props.disabled}
    options={props.options}
  />;
}

function Tax (props) {
  return <DetailsRow
    title='CALCULATION_INCOME_TAX'
    left={<ToolTip id='tax' msg={proxyCounterpart('TOOLTIP_CALCULATION_INCOME_TAX')}/>}
    right={props.calculation}
  />;
}

function ToggleSummation (props) {
  const showCalculation = !props.hideCalculation ? 'hidden' : '';
  const hideCalculation = props.hideCalculation ? 'hidden' : '';

  return (
    <div className='hide-show-calculation'>
      <div className={'showCalculation ' + showCalculation} onClick={props.onClick}>
        + <Translate content='SHOW_CALCULATION'/>
      </div>
      <div className={'hideCalculation ' + hideCalculation} onClick={props.onClick}>
        - <Translate content='HIDE_CALCULATION'/>
      </div>
    </div>);
}

function ExtraDescription (props) {
  return (
    <span className='extra-description'>
      <Translate content={props.text}/>{' '}
      <a
        target="_blank"
        href={proxyCounterpart(props.linkUrl)}
      >{proxyCounterpart(props.linkText)}</a>
    </span>
  );
}

function Travel (props) {
  let value = props.invoiceUser.calculation ? props.invoiceUser.calculation.travel : 0;
  if (props.value.userId === props.invoiceUser.userId && props.value.value !== 0 && props.value.type === 'TRAVEL') {
    value = props.value.value;
  }

  return generateInputRow(
    props,
    'TRAVEL_ALLOWANCE',
    'invoice-travel-' + props.invoiceUser.userId,
    value,
    <ToolTip
      id='travel'
      msg={proxyCounterpart('TOOLTIP_TRAVEL_ALLOWANCE')}
    />,
    <ExtraDescription
      text='TRAVEL_ALLOWANCE_REMEMBER'
      linkText='TRAVEL_ALLOWANCE_REMEMBER_LINK_TEXT'
      linkUrl='TRAVEL_ALLOWANCE_REMEMBER_LINK_URL'
    />,
    'with-extra-description'
  );
}

function Vacation (props) {
  if (props.saveVacation) {
    return <DetailsRow
      title='VACATION_MONEY'
      left={<ToolTip id='vacation' msg={proxyCounterpart('TOOLTIP_VACATION')}/>}
      right={props.calculation}
    />;
  }
  return null;
}

// PropTypes
generateInputRow.propTypes = {
  currencyName: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
  focus: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired
};

DetailsRow.propTypes = {
  detailsRowClass: PropTypes.string,
  onClick: PropTypes.func,
  title: PropTypes.string,
  left: PropTypes.any,
  right: PropTypes.any
};

InputRow.propTypes = {
  detailsRowClass: PropTypes.string,
  toolTip: PropTypes.element.isRequired,
  value: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  extraDescription: PropTypes.element,
  currencyName: PropTypes.string.isRequired,
  id: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  disabled: PropTypes.bool.isRequired,
  onBlur: PropTypes.func.isRequired,
  focus: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired
};

SelectRow.propTypes = {
  left: PropTypes.node,
  title: PropTypes.string.isRequired,
  id: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  options: PropTypes.node.isRequired
};

AddCoworker.propTypes = {
  onClick: PropTypes.func.isRequired
};

Allowance.propTypes = {
  invoiceUser: PropTypes.object.isRequired,
  value: PropTypes.object.isRequired
};

CoworkerName.propTypes = {
  invoiceUser: PropTypes.object.isRequired,
  coworkerId: PropTypes.number.isRequired,
  removeCoworker: PropTypes.func.isRequired
};

DeductionAmount.propTypes = {
  calculation: PropTypes.object.isRequired
};

Divider.propTypes = {
  hide: PropTypes.bool,
  saveVacationPay: PropTypes.bool,
  discount: PropTypes.number
};

Gross.propTypes = {
  invoiceUser: PropTypes.object.isRequired,
  value: PropTypes.object.isRequired
};

HourlySalary.propTypes = {
  title: PropTypes.string.isRequired,
  calculation: PropTypes.string.isRequired
};

InvoiceryFee.propTypes = {
  calculation: PropTypes.string.isRequired
};

RewardsDiscount.propTypes = {
  calculation: PropTypes.string.isRequired,
  discount: PropTypes.number
};

Net.propTypes = {
  invoiceUser: PropTypes.object.isRequired,
  value: PropTypes.object.isRequired
};

PayrollTax.propTypes = {
  calculation: PropTypes.string.isRequired
};

Pension.propTypes = {
  calculation: PropTypes.string.isRequired
};

PensionTax.propTypes = {
  calculation: PropTypes.string.isRequired
};

SelectTax.propTypes = {
  title: PropTypes.string.isRequired,
  invoiceUser: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  options: PropTypes.node.isRequired
};

Tax.propTypes = {
  calculation: PropTypes.string.isRequired
};

ToggleSummation.propTypes = {
  hideCalculation: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired
};

Travel.propTypes = {
  invoiceUser: PropTypes.object.isRequired,
  value: PropTypes.object.isRequired
};

Vacation.propTypes = {
  saveVacation: PropTypes.bool.isRequired,
  calculation: PropTypes.string.isRequired
};

ExtraDescription.propTypes = {
  text: PropTypes.string.isRequired,
  linkText: PropTypes.string.isRequired,
  linkUrl: PropTypes.string.isRequired
};

export {
  AddCoworker,
  Allowance,
  CoworkerName,
  DeductionAmount,
  Divider,
  Gross,
  HourlySalary,
  InvoiceryFee,
  Net,
  PayrollTax,
  Pension,
  PensionTax,
  RewardsDiscount,
  SelectTax,
  Tax,
  ToggleSummation,
  Travel,
  Vacation
};



/** WEBPACK FOOTER **
 ** ./src/views/invoice-tool/distribution/rows/distribution-rows.js
 **/